import { request } from '@blade/common';
// 获取用户列表 -zrl
export const getList = (data) => request({
    url: '/api/user-management/api/v1/ums/users',
    method: 'POST',
    data,
});
// 获取角色组 -zrl
export const getRoleGroupList = () => request({
    url: '/api/user-management/api/v1/ums/role/tag/list',
    method: 'GET',
});
// 创建用户 -zrl
export const addUser = (data) => request({
    url: '/api/user-management/api/v1/ums/user',
    method: 'POST',
    data
});
// 编辑用户 -zrl
export const editUser = (data) => request({
    url: '/api/user-management/api/v1/ums/user',
    method: 'PATCH',
    data
});
// 删除用户 -zrl
export const deleteUser = (userId) => request({
    url: `/api/user-management/api/v1/ums/user/${userId}`,
    method: 'DELETE',
});
// 用户详情 -zrl
export const userDetail = (userId) => request({
    url: `/api/user-management/api/v1/ums/user/${userId}`,
    method: 'GET',
});
// 获取部门树 -zrl
export const getOrgTree = () => request({
    url: '/api/user-management/api/v1/ums/org/tree/',
    method: 'POST',
});
// 获取角色枚举 -zrl
export const getRoleList = () => request({
    url: '/api/user-management/api/v1/ums/role/list/all',
    method: 'POST',
});
// 获取机构枚举 -zrl
export const getOrgList = (data) => request({
    url: '/api/user-management/api/v1/ums/org/list/',
    method: 'POST',
    data
});
// 创建部门 -zrl
export const createOrg = (data) => request({
    url: '/api/user-management/api/v1/ums/org',
    method: 'POST',
    data
});
// 编辑部门 -zrl
export const modifyOrg = (data) => request({
    url: '/api/user-management/api/v1/ums/org',
    method: 'PUT',
    data
});
// 删除部门 -zrl
export const delOrg = (orgid) => request({
    url: `/api/user-management/api/v1/ums/org/${orgid}`,
    method: 'DELETE',
});
// 重置密码 -zrl
export const resetPassword = (userId) => request({
    url: `/api/user-management/api/v1/ums/user/password/reset/${userId}`,
    method: 'GET',
});
/*
启用用户 -zrl
*/
export const enableUsers = (data) => request({
    url: '/api/user-management/api/v1/ums/user/enable',
    method: 'POST',
    data
});
/*
禁用用户 -zrl
*/
export const disableUsers = (data) => request({
    url: '/api/user-management/api/v1/ums/user/disable',
    method: 'POST',
    data
});
